import { Place } from '../../../../constants/entities.types';
import { searchString } from '../../../../utils/string.util';
import { PlaceComponent } from './place';

type PlacesProps = {
    places: Place[];
    latitude: number;
    longitude: number;
    searchText: string;
};

export function Places({ places, latitude, longitude, searchText }: PlacesProps) {
    function renderPlaces() {
        return places.map((place, index) => {
            const isInSearch = searchString(searchText, [place.name, place.address]);

            if (!isInSearch) {
                return undefined;
            }

            return (
                <PlaceComponent
                    key={`${place}-${index}`}
                    place={place}
                    latitude={latitude}
                    longitude={longitude}
                />
            );
        });
    }

    return <div>{renderPlaces()}</div>;
}
